import React, { useState, useEffect } from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import { getWebV2Url } from '../../services/Common';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    height: 'calc(100vh - 64px)'
  },
  loaderContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  alert: {
    margin: theme.spacing(2)
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none'
  }
}));

const AppV2Integration = ({ baseUrl = process.env.REACT_APP_V2_URL, path }) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [iframeUrl, setIframeUrl] = useState('');

    baseUrl = getWebV2Url();
    
    

    useEffect(() => {
        const setupIframe = () => {
            try {
                let targetPath;
                if (path) {
                    targetPath = path;
                } else {
                    // Get current path excluding the base path
                    targetPath = window.location.pathname.replace('/admin/app/v2/', '');
                }
                const searchParams = window.location.search;
                
                // Construct the full URL for the iframe
                // Ensure targetPath starts with / if not present (unless it's empty)
                if (targetPath && !targetPath.startsWith('/')) {
                    targetPath = '/' + targetPath;
                }
                
                const fullUrl = `${baseUrl}${targetPath}${searchParams}`;
                setIframeUrl(fullUrl);
            } catch (err) {
                console.error('Error setting up iframe:', err);
                setError('Failed to load the application');
            } finally {
                setLoading(false);
            }
        };

        setupIframe();
    }, [baseUrl, path]);

    const handleIframeLoad = () => {
        setLoading(false);
    };

    const handleIframeError = () => {
        setError('Failed to load the application');
        setLoading(false);
    };

    return (
        <Box className={classes.root}>
            {loading && (
                <Box className={classes.loaderContainer}>
                    <CircularProgress />
                </Box>
            )}
            
            {error && (
                <Alert 
                    severity="error" 
                    className={classes.alert}
                >
                    {error}
                </Alert>
            )}

            <iframe
                src={iframeUrl}
                className={classes.iframe}
                style={{ display: loading ? 'none' : 'block' }}
                onLoad={handleIframeLoad}
                onError={handleIframeError}
                title="App V2 Integration"
            />
        </Box>
    );
};

export default AppV2Integration;
